import React from 'react';

export const ROLE_OPTIONS = [
  'Buyer',
  'Procurement Leadership',
  'Executive',
  'Private Equity',
  'Operations',
  'Sales',
  'Other',
] as const;

const inputCls = 'mt-3 p-3 rounded-sm w-full bg-transparent border border-rs-jet text-rs-off-white placeholder-rs-off-white/60 focus:border-rs-green focus:outline-none';

interface RoleFieldsProps {
  buyingRole: string;
  buyingRoleOther: string;
  jobTitle: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onBuyingRoleOtherChange: (value: string) => void;
}

const RoleFields: React.FC<RoleFieldsProps> = ({ buyingRole, buyingRoleOther, jobTitle, onChange, onBuyingRoleOtherChange }) => (
  <>
    <select
      className="mt-3 p-3 rounded-sm w-full bg-rs-black border border-rs-jet text-rs-off-white focus:border-rs-green focus:outline-none"
      name="buying_role"
      value={buyingRole}
      onChange={onChange}
      required
    >
      <option value="" disabled>What best describes your role?</option>
      {ROLE_OPTIONS.map(opt => <option key={opt}>{opt}</option>)}
    </select>
    {buyingRole === 'Other' && (
      <input
        className={inputCls}
        placeholder="Please describe your role"
        value={buyingRoleOther}
        onChange={e => onBuyingRoleOtherChange(e.target.value)}
      />
    )}
    <input
      className={inputCls}
      name="job_title"
      placeholder="Job Title (optional)"
      value={jobTitle}
      onChange={onChange}
    />
  </>
);

export default RoleFields;
